import jwtDecode from 'jwt-decode';
// import 'babel-polyfill';
// import fetch from 'cross-fetch';
require('dotenv').config()

const url = "https://hz9h9te1he.execute-api.us-east-2.amazonaws.com/development";

export default {
    // called when the user attempts to log in
    login: ({ username, password }) => {
        const request = new Request(url + "/sessions/admin", {
            method: 'POST',
            body: JSON.stringify({ username, password }),
            headers: new Headers({ 'Content-Type': 'application/json' }),
        });
        return fetch(request)
            .then(response => {
                if (response.status < 200 || response.status >= 300) {
                    throw new Error(response.json().message);
                }
                return response.json();
            })
            .then((data) => {
                if (data.challenge) {
                    const decodedToken = jwtDecode(data.challenge);
                    // console.log(decodedToken);
                    // console.log(decodedToken);
                    localStorage.setItem('cha', decodedToken.ChallengeName);
                    localStorage.setItem('sess', decodedToken.Session);
                    localStorage.setItem('ubs', username);
                    var getUrl = window.location;
                    var baseUrl = getUrl.protocol + "//" + getUrl.host
                    // console.log(localStorage.getItem("cha"));
                    // console.log(localStorage.getItem("sess"));
                    window.location = baseUrl + "/#/challenge";
                    // return Promise.resolve({ redirectTo: "/#/challenge" });
                } else if (data.token) {
                    try {
                        const decodedToken = jwtDecode(data.token);
                        localStorage.setItem('token', data.token);
                        localStorage.setItem('expiration', Date.now() + decodedToken.expires_in * 1000);
                        localStorage.setItem('permissions', decodedToken.permissions);
                        localStorage.setItem('permits', decodedToken._permissions);
                        localStorage.setItem('email', decodedToken.email);
                        localStorage.setItem('ubs', username);
                    } catch (e) {
                        console.log(e);
                        return Promise.reject();
                    }
                    // console.log(localStorage.getItem("token"));
                }
                // return Promise.resolve();
            });
    },
    logout: () => {
        localStorage.removeItem('token');
        localStorage.removeItem('permissions');
        localStorage.removeItem('permits');
        localStorage.removeItem('cha');
        localStorage.removeItem('expiration');
        localStorage.removeItem('email');
        localStorage.removeItem('ubs');
        localStorage.removeItem('sess');
        return Promise.resolve();
    },
    // called when the API returns an error
    checkError: (error) => {
        const status = error.status;
        if (status === 401 || status === 403) {
            localStorage.removeItem('token');
            localStorage.removeItem('permissions');
            localStorage.removeItem('permits');
            return Promise.reject();
        }
        return Promise.resolve();
    },
    // called when the user navigates to a new location, to check for authentication
    checkAuth: () => {
        if (localStorage.getItem('cha') != null) {
            var getUrl = window.location;
            var baseUrl = getUrl.protocol + "//" + getUrl.host
            window.location = baseUrl + "/#/challenge";
            return Promise.resolve("challenge");
        }
        // console.log(localStorage.getItem('permits'));
        try {
            if (!localStorage.getItem('permits')) {
                return Promise.reject();
            } else if (localStorage.getItem('expiration') && localStorage.getItem('expiration') > Date.now()) {
                return localStorage.getItem('token') ? Promise.resolve() : Promise.reject();
            } else {
                return Promise.reject()
            }
        } catch (e) {
            alert(e);
            return Promise.reject()
        }
    },
    // called when the user navigates to a new location, to check for permissions / roles
    getPermissions: () => {
        if (!localStorage.getItem('token') && localStorage.getItem('cha') == null) { return Promise.reject(); }
        if (localStorage.getItem('cha') != null) {
            return Promise.resolve("challenge");
        }
        const { _permissions } = jwtDecode(localStorage.getItem('token'));
        if (_permissions === undefined) {
            return Promise.resolve("");
        }
        return Promise.resolve(_permissions);
    }
};